import { UserRole } from '../auth/roles.enum';
import { Communication } from '../../shared/communications/communication.model';
import { Company } from '../../features/companies/company.model';
import { Contact } from '../../features/contacts/contact.model';
import { Project } from '../../features/projects/project.model';
import { Note } from '../../shared/notes/note.model';
import { UserSettings } from './user-settings.model';

export class User {

  _id?: string;
  email?: string;
  telephone?: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean = false;
  role?: UserRole;
  jobTitle?: string;
  isTeamMember: boolean = false;
  isExternalUser: boolean = false;
  photoUrl: string = '/assets/img/logo/Company.png'; 

  // settings: string = '';
  userSettings: UserSettings = new UserSettings();

  /* get all the details */
  // companies: Company[] = [];
  // contacts: Contact[] = [];
  // projects: Project[] = [];
  // notes: Note[] = [];
  // communications: Communication[] = [];

  lastUpdated: Date;

  get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

}



// WEBPACK FOOTER //
// ./client/app/core/user/user.model.ts